module.exports = __webpack_public_path__ + "media/images/dummyobat-da826f8a.svg";